import React, { FunctionComponent, ReactNode } from 'react';
import { makeStyles, Grid, Typography, Avatar, Divider, List, ListItem } from '@rbx/ui';
import { Thumbnail2d, ThumbnailTypes } from '@rbx/thumbnails';
import TopNavigationDrawer from './TopNavigationDrawer';
import { User } from './types';
import TopNavigationDrawerProductHeader from './TopNavigationDrawerProductHeader';
import NavigationTranslate from '../../hooks/NavigationTranslate';

type AuthenticationStatusDrawerProps = {
  user: User;
  open: boolean;
  onClickClose: () => void;
  onLogout: () => void;
  onSettingsClick: () => void;
  mobileDropdownContent: ReactNode;
};
const useAuthenticationStatusDrawerstyles = makeStyles()(theme => ({
  userName: {
    marginLeft: 10,
    textTransform: 'none'
  },

  drawerContent: {
    padding: theme.spacing(2, 3)
  },

  drawerAvatar: {
    padding: theme.spacing(2, 0)
  }
}));

const AuthenticationStatusDrawer: FunctionComponent<AuthenticationStatusDrawerProps> = ({
  user,
  open,
  onLogout,
  onClickClose,
  onSettingsClick,
  mobileDropdownContent
}) => {
  const {
    classes: { drawerContent, drawerAvatar, userName }
  } = useAuthenticationStatusDrawerstyles();

  return (
    <TopNavigationDrawer open={open} onClose={onClickClose}>
      <TopNavigationDrawerProductHeader
        header={<NavigationTranslate content='Heading.Creator' />}
        onClickClose={onClickClose}
      />
      <div className={drawerContent}>
        <Grid container direction='row' alignItems='center' className={drawerAvatar}>
          <Grid item>
            <Avatar alt='avatar'>
              <Thumbnail2d
                targetId={user.id ?? 0}
                type={ThumbnailTypes.avatarHeadshot}
                alt={user.name ?? ''}
              />
            </Avatar>
          </Grid>
          <Grid item className={userName}>
            <Typography variant='largeLabel2' color='secondary'>
              {user.name}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <List onClick={onClickClose}>
          {mobileDropdownContent}
          <ListItem onClick={onSettingsClick}>
            <Typography>
              <NavigationTranslate content='Heading.Settings' />
            </Typography>
          </ListItem>
          <ListItem onClick={onLogout}>
            <Typography>
              <NavigationTranslate content='Action.LogOut' />
            </Typography>
          </ListItem>
        </List>
      </div>
    </TopNavigationDrawer>
  );
};

export default AuthenticationStatusDrawer;
